import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[lng]/components/faqs-search-results/faqs-search-results.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/icons/learnMore.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/icons/search-icon.svg");
